import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

import { BACKEND_URL } from '../config';
const API_URL = `${BACKEND_URL}/api`;

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  
  // Support both Stripe (session_id) and Tpay (tpay_id)
  const sessionId = searchParams.get('session_id');
  const tpayId = searchParams.get('tpay_id');
  const paymentId = sessionId || tpayId;
  const paymentType = sessionId ? 'stripe' : 'tpay';

  useEffect(() => {
    if (paymentId) {
      checkPaymentStatus();
    }
  }, [paymentId, attempts]);

  const checkPaymentStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Use appropriate endpoint based on payment type
      const endpoint = paymentType === 'tpay' 
        ? `${API_URL}/payments/tpay/status/${paymentId}`
        : `${API_URL}/payments/status/${paymentId}`;
      
      const response = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const paymentStatus = response.data.payment_status || response.data.status;
      
      if (paymentStatus === 'paid') {
        setStatus('success');
      } else if (attempts < 5) {
        setTimeout(() => setAttempts(attempts + 1), 2000);
      } else {
        setStatus('timeout');
      }
    } catch (error) {
      console.error('Error checking status:', error);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-surface flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-floating p-8 text-center">
        {status === 'checking' && (
          <>
            <Loader2 className="w-16 h-16 text-primary-500 animate-spin mx-auto mb-6" />
            <h1 className="font-heading text-2xl text-primary-900 mb-2">Weryfikacja płatności...</h1>
            <p className="text-muted-foreground">Proszę czekać, sprawdzamy status płatności</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
            <h1 className="font-heading text-2xl text-primary-900 mb-2">Płatność zakończona!</h1>
            <p className="text-muted-foreground mb-6">
              Twoja subskrypcja została aktywowana. Dziękujemy za zakup!
            </p>
            <Button onClick={() => navigate('/dashboard')} className="w-full">
              Przejdź do Dashboard
            </Button>
          </>
        )}

        {status === 'timeout' && (
          <>
            <h1 className="font-heading text-2xl text-primary-900 mb-2">Weryfikacja trwa dłużej...</h1>
            <p className="text-muted-foreground mb-6">
              Sprawdź status subskrypcji za chwilę lub skontaktuj się z nami.
            </p>
            <Button onClick={() => navigate('/dashboard')} className="w-full">
              Powrót do Dashboard
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="font-heading text-2xl text-primary-900 mb-2">Wystąpił błąd</h1>
            <p className="text-muted-foreground mb-6">
              Nie udało się zweryfikować płatności. Skontaktuj się z nami.
            </p>
            <Button onClick={() => navigate('/subscription')} className="w-full">
              Spróbuj ponownie
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
